import FooterApp from "./react-footer";
import { ComponentBootstrap } from "@demant/react-bootstrap";
import flexSpotSchema from "@demant/react-bootstrap/lib/schemas/flex-spot";
var footerApp = new ComponentBootstrap(".footer .flex-spot");
footerApp.schemaData = flexSpotSchema;
footerApp.reactApp = FooterApp;
footerApp.run();